import { getCurrentColor } from "common/utils/enhanced-url-generator";

const ACTIVE_COLOR_QUERY_PARAM = "ac";

export const normalizeCompositionName = compositionName => {
  if (!compositionName) return "";

  const raw = compositionName.toString().replace(/\+/g, " ").trim();
  const withoutUrlSuffix = raw.split(/[?#]/)[0] || "";

  try {
    return decodeURIComponent(withoutUrlSuffix).trim().replace(/\s+/g, " ");
  } catch {
    return withoutUrlSuffix.trim().replace(/\s+/g, " ");
  }
};

export const getCompositionNameFromQueryParam = (queryParam = ACTIVE_COLOR_QUERY_PARAM) => {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(queryParam);
  return value ? normalizeCompositionName(value) : "";
};

export const getCompositionNameFromLocation = (queryParam = ACTIVE_COLOR_QUERY_PARAM) => {
  const fromQueryParam = getCompositionNameFromQueryParam(queryParam);
  if (fromQueryParam) return fromQueryParam;

  return normalizeCompositionName(getCurrentColor()?.color);
};

export const resolveCompositionName = ({
  containerSelectedColor,
  activeColorName,
  queryParam = ACTIVE_COLOR_QUERY_PARAM,
  preferQueryParam = false
} = {}) => {
  if (preferQueryParam) {
    const fromQueryParam = getCompositionNameFromQueryParam(queryParam);
    if (fromQueryParam) return fromQueryParam;
  }

  const fromContainer = normalizeCompositionName(containerSelectedColor);
  if (fromContainer) return fromContainer;

  const fromActiveElement = normalizeCompositionName(activeColorName);
  if (fromActiveElement) return fromActiveElement;

  return getCompositionNameFromLocation(queryParam);
};
